import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getProjectById } from 'apis/projects.api';
import { mapError } from 'utils/func';
import Loading from 'components/Loading';
import DetailContractInfo from '../../components/DetailContractInfo';

function DetailContract() {
  const { t } = useTranslation();
  const { projectId } = useParams();

  const {
    data: _data,
    isLoading,
    isError,
    error: errorProject
  } = useQuery(['projectDetail'],
    () => getProjectById(projectId)
  );

  const data = useMemo(() => _data ?? [], [_data]);

  if (isLoading) {
    return <Loading />;
  }

  if (isError) {
    return <h4 className="text-red-500">{mapError(t, errorProject)}</h4>;
  }

  return (
    <DetailContractInfo
      data={data.data.projectProposal}
      dataContract={data.data}
    />
  );
}

export default DetailContract;
